import React, { useState } from "react";
import { PLATFORM_BRAND, PLATFORM_INITIAL, PLATFORM_LOGO } from "../lib/config";

/**
 * BrandMark — affiche le logo (image) + le nom de la plateforme bicolore.
 *
 * Props :
 *  - size: "sm" | "md" | "lg" (taille du logo / texte)
 *  - showText: bool (par défaut true)
 *  - className: string optionnel
 */
const SIZES = {
  sm: { box: "h-7 w-7", initial: "text-xs", text: "text-sm" },
  md: { box: "h-8 w-8", initial: "text-sm", text: "text-base" },
  lg: { box: "h-10 w-10", initial: "text-base", text: "text-lg" },
  xl: { box: "h-14 w-14", initial: "text-lg", text: "text-2xl" },
  "2xl": { box: "h-20 w-20", initial: "text-xl", text: "text-3xl" },
};

export default function BrandMark({ size = "md", showText = true, className = "", monochrome = false, uppercase = false }) {
  const [logoOk, setLogoOk] = useState(Boolean(PLATFORM_LOGO));
  const s = SIZES[size] || SIZES.md;

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-mark" translate="no">
      {/* Slot logo entreprise : si /logo.png existe, on l'affiche ; sinon monogramme */}
      {logoOk ? (
        <img
          src={PLATFORM_LOGO}
          alt="Maak Work"
          translate="no"
          onError={() => setLogoOk(false)}
          className={`${s.box} object-contain rounded-sm notranslate`}
          data-testid="brand-logo"
        />
      ) : (
        <div
          className={`${s.box} bg-[#18181B] flex items-center justify-center rounded-sm notranslate`}
          aria-hidden="true"
          translate="no"
          data-testid="brand-monogram"
        >
          <span className={`text-white font-display font-bold ${s.initial}`}>{PLATFORM_INITIAL}</span>
        </div>
      )}

      {showText && (
        <div
          className={`font-display font-bold tracking-tight notranslate whitespace-nowrap ${s.text} ${uppercase ? "uppercase tracking-wider" : ""}`}
          data-testid="platform-name"
          translate="no"
          lang="en"
        >
          {PLATFORM_BRAND.map((part, i) => (
            <span
              key={i}
              translate="no"
              style={{ color: monochrome ? "#18181B" : part.color }}
            >
              {part.text}
              {i < PLATFORM_BRAND.length - 1 && " "}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
